import * as React from 'react';
import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';

import { Dropdown } from '@process-advisor/process-miner/components/shared/dropdown';

export const Metrics = () => {
    const [value, setValue] = React.useState<number>(3);

    let options = [
            { value: 2, label: 'Duration (mins)' },
            { value: 3, label: 'Duration (hrs)' },
            { value: 4, label: 'Duration (days)' },
        ];

        const onChange = (value: number) => {
        setValue(value);
        apiProvider.applyInfluenceAnalysisMetricFilter({metricFilter: value})
    };

    React.useEffect(() => {
        setValue(apiProvider.getInfluenceAnalysisMetricFilter());
    }, []);

    return (
        <Dropdown
            options={options}
            onChange={onChange}
            value={value} />
    );
};

